<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-4">
        <z-input
          v-model="contactName"
          name="contactName"
          label="Contact Name"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4">
        <z-input
          v-model="phoneContact"
          name="phoneContact"
          label="Contact Phone"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4"></div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <z-input
          v-model="contactEmail"
          name="contactEmail"
          label="Contact Email"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-8"></div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
export default {
  name: 'organization-contact',
  components: {
    ZInput,
    ZSelect,
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    phoneContact: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.contactPhone
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'contactPhone',
          value: value,
        })
      },
    },
    contactName: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.contactName
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'contactName',
          value: value,
        })
      },
    },
    contactEmail: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.contactEmail
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'contactEmail',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['setOrganizationData']),
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
